/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2025 ICEMEDX, Inc.
***********************************************/
import { notebookpage } from './notebookpage';

export class notebookpageindex extends notebookpage {
  notebook_page_index_key: string = "";
  types: string = "";

  constructor(attr: any = {}) {
    super(attr);
  }

  public gettablename(): string {
    return "NOTEBOOK_PAGE_INDEX";
  }
}
